import { 
  fmtBytes
} from '../../utils/formatters';

export function getCompletedInputObjects(inputs) {
    if(!inputs) {
        return 0;
    }
    const failed=inputs.Failed.Objects || 0;
    const skipped=inputs.Skipped.Objects || 0;
    const succeeded=inputs.Succeeded.Objects || 0;
    const rejected=inputs.Rejected.Objects || 0;
    return failed+skipped+succeeded+rejected;    
}

export function getCompletedInputBytes(inputs) {
    if(!inputs) {
        return 0;
    }
    const failed=inputs.Failed.Bytes || 0;
    const skipped=inputs.Skipped.Bytes || 0;
    const succeeded=inputs.Succeeded.Bytes || 0;
    const rejected=inputs.Rejected.Bytes || 0;
    return failed+skipped+succeeded+rejected;    
}

export function getOutputObjects(outputs) {
    if(!outputs) {
        return 0;
    }
    const artifacts=outputs.Artifacts.Objects || 0;
    const data=outputs.Data.Objects || 0;
    const diagnostics=outputs.Diagnostics.Objects || 0;
    const samples=outputs.Samples.Objects || 0;
    return artifacts+data+diagnostics+samples;    
}

export function getOutputBytes(outputs) {
    if(!outputs) {
        return 0;
    }
    const artifacts=outputs.Artifacts.Bytes || 0;
    const data=outputs.Data.Bytes || 0;
    const diagnostics=outputs.Diagnostics.Bytes || 0;
    const samples=outputs.Samples.Bytes || 0;
    return artifacts+data+diagnostics+samples;    
}

export function getOverallSeconds(metrics) {
    return metrics?metrics.Seconds.Overall:0;
}

export function fmtExecutionObjectIOPerMin(execution) {
    const mins=getOverallSeconds(execution.Metrics)/60;
    const inputs=getCompletedInputObjects(execution.Inputs);
    const ipm=mins?Math.round(inputs/mins):0;
    const outputs=getOutputObjects(execution.Outputs);
    const opm=mins?Math.round(outputs/mins):0;
    const result=`${ipm} => ${opm}`;
    return result;
}

export function fmtExecutionBytesOutputPerMin(execution) {
    const mins=getOverallSeconds(execution.Metrics)/60;
    const bytes=getOutputBytes(execution.Outputs);
    const bpm=mins?bytes/mins:0;
    return fmtBytes(bpm);
}
